<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    :stroke="stroke"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
    class=""
  >
    <path
      d="M22 22l-6.344-6.344M10 18a8 8 0 100-16 8 8 0 000 16z"
      stroke="inherit"
      fill="none"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    stroke: {
      type: String,
    },
  },
};
</script>
